import React, { useEffect, useState } from 'react';
// import { Button, Modal, Input, Space } from 'antd';
import { Input } from 'antd';
import { Modal, Button } from 'react-bootstrap';


const { TextArea } = Input;
  const CommentBox =({show, handleCommentDialogueSubmit, name ,handleCancel })=>{
    
    const [comment, setComment] = useState('')
    

    useEffect(()=>{setComment('')},[show])
   
    return(
      <>

<Modal
        show={show}
        onHide={() => handleCancel()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Please enter a comment as to why the {name}  have been set to N/A</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <TextArea placeholder='enter comment' onChange={(e) =>  setComment(e.target.value)}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCancel()}>
          Cancel
          </Button>
          <Button variant="primary" onClick={() => handleCommentDialogueSubmit(comment)} disabled={!comment} >Save</Button>
        </Modal.Footer>
      </Modal>
      </>
    )
  }

export default CommentBox;
